// document.addEventListener("DOMContentLoaded", () => {
//   let progressBarContainer = document.querySelector("#upCart");
//   const shadowRoot = progressBarContainer.shadowRoot; // Only works if mode: 'open'
//   createStableDebouncer(shadowRoot, (mutation) => {
//     console.log("Mutation detected:", mutation);
//     checkAndUpdateCart();

//   })

//   // Method 3: Debounced Observer (prevents rapid-fire triggers)
//   function createStableDebouncer(element, callback, delay = 100) {
//     if (!element) return null;

//     let timeoutId;
//     let observer;

//     const createObserver = () => {
//       observer = new MutationObserver((mutations) => {
//         // Immediately disconnect to prevent further triggers
//         observer.disconnect();

//         clearTimeout(timeoutId);
//         timeoutId = setTimeout(() => {
//           // Execute callback
//           callback(mutations);

//           // Reconnect after another delay to let DOM settle
//           setTimeout(() => {
//             if (observer) {
//               observer = createObserver();
//             }
//           }, delay);
//         }, delay);
//       });

//       observer.observe(element, {
//         childList: true,
//         attributes: true,
//         subtree: true,
//         characterData: true
//       });

//       return observer;
//     };

//     observer = createObserver();

//     return {
//       disconnect: () => {
//         clearTimeout(timeoutId);
//         observer?.disconnect();
//         observer = null;
//       }
//     };
//   }




//   async function checkAndUpdateCart() {

//     let progressBarContainer = document.querySelector("#upCart");

//     const shadowRoot = progressBarContainer.shadowRoot; // Only works if mode: 'open'
//     const innerElement = shadowRoot.querySelector('.upcart-rewards');
//     // const innerElemen
//     //   document.querySelector("#upCart").shadowRoot.querySelector("#CartPopup > div > div.upcart-cart-body.styles_CartPreview__body__ > div:nth-child(3) > div")


//     const subscriptionElement = shadowRoot.querySelector('.upcart-item-property-subscription');


//     let progressBarInnerHTML = `
// <div class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">
//     <div class="upcart-rewards-message">
//         <p><span style="color: rgb(48,48,48);background-color: rgb(255,255,255);font-size: 13px;font-family: Inter, -apple-system, "
//                 system-ui",="" "san="" francisco" ,="" "segoe="" ui" ,="" roboto,="" "helvetica="" neue" ,=""
//                 sans-serif;"=""><strong>Congrats! You get free standard shipping.</strong></span></p>
//     </div>
//     <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__"
//         style="background-color: rgb(226, 226, 226);">
//         <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__"
//             style="background-color: rgb(255, 128, 151); width: 100%;"></div>
//     </div>
//     <div class="styles_TieredRewards__tiersContainer__">
//         <div></div>
//         <div
//             class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__">
//             <div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__"
//                 style="background-color: rgb(255, 128, 151); fill: rgb(226, 226, 226);">
//                 <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;"><svg
//                         viewBox="0 0 20 20">
//                         <path fill-rule="evenodd"
//                             d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z">
//                         </path>
//                         <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
//                     </svg></div>
//             </div>
//             <div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div>
//         </div>
//     </div>
// </div>
//   `
//     console.log("SUBSCRIPTION ELEMENT", subscriptionElement);

//     let progressBarInnerHTMLNoSubscription = `
//     <div><div class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor"><div class="upcart-rewards-message"><p><strong>You’re $49 away from free standard shipping!</strong></p>
// </div><div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(226, 226, 226);"><div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(255, 128, 151); width: 53.3333%;"></div></div><div class="styles_TieredRewards__tiersContainer__"><div></div><div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__"><div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__" style="border: 2px solid rgb(255, 128, 151); background-color: rgb(226, 226, 226); fill: rgb(255, 128, 151);"><div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;"><svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg></div></div><div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div></div></div></div></div>
// `

//     if (innerElement && subscriptionElement) {

//       innerElement.innerHTML = progressBarInnerHTML;

//     } else if (innerElement && !subscriptionElement) {

//       // Get cart total from Shopify
//       let cartTotal = 0;

//       try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();

//         console.log("Cart data:", cart);
//         cartTotal = cart.total_price / 100;
//         console.log("Cart total:", cartTotal);

//         // Calculate remaining amount for free shipping (assuming $75 threshold)
//         const freeShippingThreshold = 45;
//         const remainingAmount = Math.max(0, freeShippingThreshold - cartTotal);
//         const progressPercentage = Math.min(100, (cartTotal / freeShippingThreshold) * 100);

//         // Update the message and progress bar
//         progressBarInnerHTMLNoSubscription = progressBarInnerHTMLNoSubscription
//           .replace('You’re $49 away from free standard shipping!',
//             remainingAmount > 0 ? `You're $${remainingAmount.toFixed(0)} away from free standard shipping!` : 'Congrats! You get free standard shipping.')
//           .replace('width: 53.3333%;', `width: ${progressPercentage}%;`);

//         console.log("Progress bar inner HTML:", progressBarInnerHTMLNoSubscription);

//         innerElement.innerHTML = progressBarInnerHTMLNoSubscription;
//       } catch (error) {
//         console.error('Error fetching cart:', error);
//       }
//     }
//   }
// });




// document.addEventListener("DOMContentLoaded", () => {
//   let progressBarContainer = document.querySelector("#upCart");
//   const shadowRoot = progressBarContainer.shadowRoot;

//   // Store previous cart state to compare
//   let previousCartState = null;

//   // Solution 1: Cart State Comparison (Recommended)
//   createCartStateObserver(shadowRoot, async () => {
//     const currentCartState = await getCartState();

//     // Only proceed if cart actually changed
//     if (hasCartChanged(previousCartState, currentCartState)) {
//       console.log("Cart actually changed:", currentCartState);
//       previousCartState = currentCartState;
//       await checkAndUpdateCart();
//     }
//   });

//   // Get current cart state for comparison
//   async function getCartState() {
//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();

//       // Return only the essential cart data we care about
//       return {
//         itemCount: cart.item_count,
//         totalPrice: cart.total_price,
//         items: cart.items.map(item => ({
//           id: item.id,
//           quantity: item.quantity,
//           variant_id: item.variant_id
//         }))
//       };
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       return null;
//     }
//   }

//   // Compare cart states to see if anything meaningful changed
//   function hasCartChanged(previous, current) {
//     if (!previous || !current) return true;

//     // Quick checks first
//     if (previous.itemCount !== current.itemCount) return true;
//     if (previous.totalPrice !== current.totalPrice) return true;
//     if (previous.items.length !== current.items.length) return true;

//     // Deep comparison of items
//     for (let i = 0; i < current.items.length; i++) {
//       const currentItem = current.items[i];
//       const previousItem = previous.items.find(item => item.id === currentItem.id);

//       if (!previousItem || previousItem.quantity !== currentItem.quantity) {
//         return true;
//       }
//     }

//     return false;
//   }

//   // More targeted observer with longer debounce
//   function createCartStateObserver(element, callback, delay = 500) {
//     if (!element) return null;

//     let timeoutId;
//     let observer;

//     observer = new MutationObserver((mutations) => {
//       // Check if mutations are relevant to cart content
//       const relevantMutation = mutations.some(mutation => {
//         // Only care about structural changes, not style/attribute changes
//         if (mutation.type === 'childList') return true;

//         // Only care about specific attribute changes
//         if (mutation.type === 'attributes') {
//           const relevantAttributes = ['data-quantity', 'data-price', 'data-variant-id'];
//           return relevantAttributes.includes(mutation.attributeName);
//         }

//         return false;
//       });

//       if (!relevantMutation) return;

//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(callback, delay);
//     });

//     observer.observe(element, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       attributeFilter: ['data-quantity', 'data-price', 'data-variant-id'] // Only watch relevant attributes
//     });

//     return {
//       disconnect: () => {
//         clearTimeout(timeoutId);
//         observer?.disconnect();
//       }
//     };
//   }

//   // Alternative Solution 2: Shopify Cart Events (if available)
//   function listenToShopifyCartEvents() {
//     // Listen for Shopify's built-in cart events
//     document.addEventListener('cart:updated', (event) => {
//       console.log("Shopify cart updated:", event.detail);
//       checkAndUpdateCart();
//     });

//     // Some themes trigger these custom events
//     document.addEventListener('cart:change', (event) => {
//       console.log("Cart change detected:", event.detail);
//       checkAndUpdateCart();
//     });
//   }

//   // Alternative Solution 3: Polling with State Comparison (Fallback)
//   function startCartPolling(interval = 2000) {
//     setInterval(async () => {
//       const currentCartState = await getCartState();

//       if (hasCartChanged(previousCartState, currentCartState)) {
//         console.log("Cart changed via polling:", currentCartState);
//         previousCartState = currentCartState;
//         await checkAndUpdateCart();
//       }
//     }, interval);
//   }

//   // Initialize with Shopify events as primary, observer as backup
//   listenToShopifyCartEvents();

//   // If no Shopify events fire within 5 seconds, fall back to polling
//   setTimeout(() => {
//     if (!previousCartState) {
//       console.log("No Shopify events detected, using polling fallback");
//       startCartPolling();
//     }
//   }, 5000);

//   // Your existing checkAndUpdateCart function stays the same
//   async function checkAndUpdateCart() {
//     let progressBarContainer = document.querySelector("#upCart");
//     const shadowRoot = progressBarContainer.shadowRoot;
//     const innerElement = shadowRoot.querySelector('.upcart-rewards');
//     const subscriptionElement = shadowRoot.querySelector('.upcart-item-property-subscription');

//     let progressBarInnerHTML = `
// <div class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">
//     <div class="upcart-rewards-message">
//         <p><span style="color: rgb(48,48,48);background-color: rgb(255,255,255);font-size: 13px;font-family: Inter, -apple-system, system-ui, san francisco, segoe ui, roboto, helvetica neue, sans-serif;"><strong>Congrats! You get free standard shipping.</strong></span></p>
//     </div>
//     <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(226, 226, 226);">
//         <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(255, 128, 151); width: 100%;"></div>
//     </div>
//     <div class="styles_TieredRewards__tiersContainer__">
//         <div></div>
//         <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__">
//             <div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__" style="background-color: rgb(255, 128, 151); fill: rgb(226, 226, 226);">
//                 <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;">
//                     <svg viewBox="0 0 20 20">
//                         <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
//                         <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
//                     </svg>
//                 </div>
//             </div>
//             <div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div>
//         </div>
//     </div>
// </div>`;

//     if (innerElement && subscriptionElement) {
//       innerElement.innerHTML = progressBarInnerHTML;
//     } else if (innerElement && !subscriptionElement) {
//       try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         const cartTotal = cart.total_price / 100;

//         const freeShippingThreshold = 45;
//         const remainingAmount = Math.max(0, freeShippingThreshold - cartTotal);
//         const progressPercentage = Math.min(100, (cartTotal / freeShippingThreshold) * 100);


//         console.log("Cart data:", cart);
//         let progressBarInnerHTMLNoSubscription = `
// <div><div class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">
//     <div class="upcart-rewards-message">
//         <p><strong>${remainingAmount > 0 ? `You're $${remainingAmount.toFixed(0)} away from free standard shipping!` : 'Congrats! You get free standard shipping.'}</strong></p>
//     </div>
//     <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(226, 226, 226);">
//         <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(255, 128, 151); width: ${progressPercentage}%;"></div>
//     </div>
//     <div class="styles_TieredRewards__tiersContainer__">
//         <div></div>
//         <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__">
//             <div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__" style="border: 2px solid rgb(255, 128, 151); background-color: rgb(226, 226, 226); fill: rgb(255, 128, 151);">
//                 <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;">
//                     <svg viewBox="0 0 20 20">
//                         <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
//                         <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
//                     </svg>
//                 </div>
//             </div>
//             <div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div>
//         </div>
//     </div>
// </div></div>`;

//         innerElement.innerHTML = progressBarInnerHTMLNoSubscription;
//       } catch (error) {
//         console.error('Error fetching cart:', error);
//       }
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  let progressBarContainer = document.querySelector("#upCart");
  const shadowRoot = progressBarContainer.shadowRoot;
  let previousCartState = null;

  // Initialize cart detection system
  initializeCartDetection();

  async function initializeCartDetection() {
    // Try Shopify events first (most reliable)
    setupShopifyEventListeners();

    // Fallback to mutation observer
    setupMutationObserver(shadowRoot);

    // Final fallback to polling if no events fire
    setTimeout(() => {
      if (!previousCartState) {
        console.log("No cart events detected, using polling fallback");
        startCartPolling();
      }
    }, 5000);
  }

  // Primary: Listen for Shopify's built-in cart events
  function setupShopifyEventListeners() {
    document.addEventListener('cart:updated', handleCartUpdate);
    document.addEventListener('cart:change', handleCartUpdate);
    document.addEventListener('cart:item:added', handleCartUpdate);
    document.addEventListener('cart:item:removed', handleCartUpdate);
  }

  // Secondary: Mutation observer for cart DOM changes
  function setupMutationObserver(element) {
    if (!element) return;

    let timeoutId;
    const observer = new MutationObserver((mutations) => {
      // Only proceed if mutations are relevant to cart content
      const isRelevantMutation = mutations.some(mutation => {
        if (mutation.type === 'childList') return true;
        if (mutation.type === 'attributes') {
          const relevantAttributes = ['data-quantity', 'data-price', 'data-variant-id'];
          return relevantAttributes.includes(mutation.attributeName);
        }
        return false;
      });

      if (!isRelevantMutation) return;

      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleCartUpdate, 500);
    });

    observer.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-quantity', 'data-price', 'data-variant-id']
    });
  }

  // Tertiary: Polling fallback
  function startCartPolling(interval = 3000) {
    setInterval(async () => {
      const currentCartState = await getCartState();
      if (hasCartChanged(previousCartState, currentCartState)) {
        console.log("Cart changed via polling:", currentCartState);
        previousCartState = currentCartState;
        await updateCartDisplay();
      }
    }, interval);
  }

  // Main cart update handler
  async function handleCartUpdate() {
    try {
      // Wait for cart API to fully update
      await waitForCartUpdate();

      const currentCartState = await getCartState();

      if (hasCartChanged(previousCartState, currentCartState)) {
        console.log("Cart actually changed:", currentCartState);
        previousCartState = currentCartState;
        await updateCartDisplay();
      }
    } catch (error) {
      console.error('Error handling cart update:', error);
    }
  }

  // Wait for cart API to reflect actual changes
  async function waitForCartUpdate(maxAttempts = 10, delay = 200) {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      await new Promise(resolve => setTimeout(resolve, delay));

      const newCart = await getCartState();
      if (hasCartChanged(previousCartState, newCart)) {
        return newCart;
      }
    }

    // Return current state after max attempts
    return await getCartState();
  }

  // Get current cart state from Shopify API
  async function getCartState() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      return {
        itemCount: cart.item_count,
        totalPrice: cart.total_price,
        items: cart.items.map(item => ({
          id: item.id,
          quantity: item.quantity,
          variant_id: item.variant_id,
          properties: item.properties,
          selling_plan_allocation: item.selling_plan_allocation
        }))
      };
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  // Compare cart states to detect meaningful changes
  function hasCartChanged(previous, current) {
    if (!previous || !current) return true;

    // Quick checks
    if (previous.itemCount !== current.itemCount) return true;
    if (previous.totalPrice !== current.totalPrice) return true;
    if (previous.items.length !== current.items.length) return true;

    // Deep comparison of items
    for (const currentItem of current.items) {
      const previousItem = previous.items.find(item => item.id === currentItem.id);
      if (!previousItem || previousItem.quantity !== currentItem.quantity) {
        return true;
      }
    }

    return false;
  }

  // Check if cart contains subscription items
  function hasSubscriptionInCart(cart) {
    return cart.items.some(item => {
      // Check for subscription properties
      if (item.properties) {
        const subscriptionProps = [
          'subscription',
          'Subscription',
          'delivery_frequency',
          'subscription_frequency'
        ];

        if (subscriptionProps.some(prop => item.properties[prop])) {
          return true;
        }
      }

      // Check for selling plan (Shopify subscription)
      if (item.selling_plan_allocation) {
        return true;
      }

      return false;
    });
  }

  // Update the cart display based on current state
  async function updateCartDisplay() {
    const progressBarContainer = document.querySelector("#upCart");
    const shadowRoot = progressBarContainer.shadowRoot;
    const innerElement = shadowRoot.querySelector('.upcart-rewards');

    if (!innerElement) return;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const hasSubscription = hasSubscriptionInCart(cart);

      console.log("Has subscription in cart:", hasSubscription);
      console.log("Cart items:", cart.items);

      if (hasSubscription) {
        // Subscription cart - show free shipping achieved
        innerElement.innerHTML = getSubscriptionHTML();
      } else {
        // Regular cart - show progress toward free shipping
        const cartTotal = cart.total_price / 100;
        innerElement.innerHTML = getProgressHTML(cartTotal);
      }

    } catch (error) {
      console.error('Error updating cart display:', error);
    }
  }

  // HTML for subscription cart (free shipping achieved)
  function getSubscriptionHTML() {
    return `
<div  style="padding-left: 12px; padding-right: 12px" class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">
    <div class="upcart-rewards-message">
        <p><span style="color: rgb(48,48,48);background-color: rgb(255,255,255);font-size: 13px;"><strong>Congrats! You get free standard US shipping.</strong></span></p>
    </div>
    <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(245, 232, 223);">
        <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(71, 71, 71); width: 100%;"></div>
    </div>
    <div class="styles_TieredRewards__tiersContainer__">
        <div></div>
        <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__">
            <div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__" style="background-color: rgb(71, 71, 71); fill: rgb(245, 232, 223);">
                <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;">
                    <svg viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
                        <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
                    </svg>
                </div>
            </div>
            <div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div>
        </div>
    </div>
</div>`;
  }

  // HTML for regular cart with progress toward free shipping
  function getProgressHTML(cartTotal) {
    const freeShippingThreshold = 49;
    const remainingAmount = Math.max(0, freeShippingThreshold - cartTotal);
    const progressPercentage = Math.min(100, (cartTotal / freeShippingThreshold) * 100);

    const message = remainingAmount > 0
      ? `You're $${remainingAmount.toFixed(0)} away from free standard US shipping!`
      : 'Congrats! You get free standard US shipping.';

    return `
<div  style="padding-left: 12px; padding-right: 12px" class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">
    <div class="upcart-rewards-message">
        <p><strong>${message}</strong></p>
    </div>
    <div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__" style="background-color: rgb(245, 232, 223);">
        <div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="background-color: rgb(71, 71, 71); width: ${progressPercentage}%;"></div>
    </div>
    <div class="styles_TieredRewards__tiersContainer__">
        <div></div>
        <div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--leftOfCenter__">
            <div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__" style="border: 2px solid rgb(71, 71, 71); background-color: rgb(245, 232, 223); fill: rgb(71, 71, 71);">
                <div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;">
                    <svg viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
                        <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
                    </svg>
                </div>
            </div>
            <div class="upcart-rewards-tier-description styles_rewardsDescription__">Free Shipping</div>
        </div>
    </div>
</div>`;
  }

  // Initialize the display on page load
  updateCartDisplay();
});